import React from "react";
import { navigate } from "gatsby";
import { Styling } from "./styled.js";

export default function Form() {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const params = new URLSearchParams(new FormData(form)).toString();
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: params,
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Form error: ${res.status}`);
        navigate("/");
      })
      .catch((error) => alert(error));
  };

  return (
    <Styling>
      <form
        className="form"
        id="call-to-action"
        method="POST"
        data-netlify="true"
        name="call-to-action"
        onSubmit={handleSubmit}>
        <input type="hidden" name="form-name" value="call-to-action" />
        <div className="input_wrap">
          <label htmlFor="name">Name</label>
          <input type="text" name="name" id="name" required />
        </div>
        <div className="input_wrap">
          <label htmlFor="email">Email</label>
          <input type="email" name="email" id="email" required />
        </div>
        <div className="input_wrap">
          <label htmlFor="phone">Phone</label>
          <input type="text" name="phone" id="phone" />
        </div>
        <div className="select_wrap">
          <label htmlFor="preferredContact">Preffered Contact</label>
          <select name="preferred" id="preferredContact" defaultValue="">
            <option value="" disabled>
              Please choose a preferred contact method
            </option>
            <option value="Email">Email</option>
            <option value="Phone">Phone</option>
          </select>
        </div>
        <div className="textarea_wrap">
          <label htmlFor="message">Message</label>
          <textarea name="message" id="message" />
        </div>
        <button className="submit button" type="submit">
          Send
        </button>
      </form>
    </Styling>
  );
}
